<template>
  <div>
    <div id="alertMask" class="popup_mask"></div>
    <div id="alertPop" class="popup">
      <div class="alert_popup">
        <div class="alert_wrap">
          <div class="message" :style="[ { padding: '20px'}, isHideCancel ? {} : {paddingTop: '40px'} ]">
            <span
              v-html="message"
              style="font-size: 16px; font-weight: 700; line-height:20px;"
            ></span>
          </div>

        <div v-if="isTriple" class="alert_btn dual-alert"
        style="width: 250px; margin: 0 auto; height: 68px; background: #fff">
          <button
            type="button"
            class="cstm-alert confirm-button"
            style="
                  display: block;
                  border-radius: 4px;
                  justify-content: center;
                  top: 50px;
                  width: 100%;
                  margin: 0px auto;
                  text-align: center;
                  height: 48px;
                  font-size: 14px;
                  font-weight: 800;
                  color: #333;
                "
            @click="selectA"
          >
            {{ btnA || '확인' }}
          </button>
          <button
            type="button"
            class="cstm-alert cancel-button"
            style="
                  display: block;
                  border-radius: 4px;
                  justify-content: center;
                  top: 50px;
                  width: 100%;
                  margin: 0px auto;
                  text-align: center;
                  height: 48px;
                  font-size: 14px;
                  font-weight: 800;
                  color: #333;
                "
            @click="cancel"
          >
            {{ btnB || '취소' }}
          </button>
          <button
            type="button"
            class="cstm-alert danger-button"
            style="
                  display: block;
                  border-radius: 4px;
                  justify-content: center;
                  top: 50px;
                  width: 100%;
                  margin: 0px auto;
                  text-align: center;
                  height: 48px;
                  font-size: 14px;
                  font-weight: 800;
                  color: #333;
                "
            @click="selectC"
          >
            {{ btnC || '장애이력등록' }}
          </button>
        </div>

        <div v-if="!isTriple">
          <div v-if="!isSelect"
              class="alert_btn"
              style="width: 75%; margin: 0 auto; height: 68px; background: #fff"
            >
              <button
                type="button"
                v-if="!isGray"
                @click="confirm"
                style="
                  display: block;
                  border-radius: 4px;
                  justify-content: center;
                  top: 50px;
                  width: 100%;
                  margin: 0px auto;
                  text-align: center;
                  height: 48px;
                  font-size: 14px;
                  font-weight: 800;
                  background: #a0f0e0;
                  color: #333;
                "
              >
                {{ btnA || '확인' }}
              </button>
              <button
                type="button"
                v-if="isGray"
                @click="confirm"
                style="
                  display: block;
                  border-radius: 4px;
                  justify-content: center;
                  top: 50px;
                  width: 100%;
                  margin: 0px auto;
                  text-align: center;
                  height: 48px;
                  font-size: 14px;
                  font-weight: 800;
                  background: #F0F0F0;
                  color: #333;
                "
              >
                {{ btnA || '확인' }}
              </button>
              <button
                type="button"
                v-if="isConfirm"
                @click="cancel"
                class="cancel"
                style="
                  display: block;
                  border-radius: 4px;
                  justify-content: center;
                  top: 50px;
                  width: 100%;
                  margin: 0px auto;
                  text-align: center;
                  height: 48px;
                  font-size: 14px;
                  font-weight: 800;
                  color: #333;
                "
              >
              {{ btnB || '취소' }}
              </button>
            </div>
            <div v-else
              class="alert_btn"
              style="gap:8px; width: calc(100% - 40px); margin: 0 auto; height: 68px; background: #fff"
            >
            <!-- 커스텀 영역 customSelect 사용시 노출 -->
              <button
                type="button"
                @click="confirm"
                class="cstm-alert cancel-button"
              >
                {{ btnA || '확인' }}
              </button>
              <button
                type="button"
                @click="cancel"
                class="cstm-alert confirm-button"
              >
                {{ btnB || '취소' }}
              </button>
            </div>
            <button class="close" @click="cancel" v-if="!isHideCancel">
              <i class="xi-close-min"></i>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  methods: {
    confirm: function () {
      this.closed()
      this.isShowModal = false

      if (typeof this.callback === 'function') {
        this.callback(true)
      }
    },
    cancel: function () {
      this.closed()
      this.isShowModal = false

      if (typeof this.callback === 'function') {
        this.callback(false)
      }
    },
    selectA: function () {
      this.isShowModal = false

      if (typeof this.callback === 'function') {
        this.callback('A')
      }
    },
    selectB: function () {
      this.isShowModal = false

      if (typeof this.callback === 'function') {
        this.callback('B')
      }
    },
    selectC: function () {
      this.isShowModal = false

      if (typeof this.callback === 'function') {
        this.callback('C')
      }
    },
    close: function () {
      this.closed()
      this.isShowModal = false

      if (typeof this.callback === 'function') {
        this.callback('close')
      }
    },
    open () {
      var popLeft = ($(window).width() - $('#alertPop').outerWidth()) / 2
      var popTop = ($(window).height() - $('#alertPop').outerHeight()) / 2
      if (popLeft < 0) popLeft = 0
      if (popTop < 0) popTop = 0
      $('#alertMask').fadeIn()
      $('#alertPop')
        .css({ left: popLeft, top: popTop })
        .fadeIn()
        .addClass('on')
    },
    closed () {
      $('#alertPop').fadeOut().removeClass('on')
      $('#alertMask').fadeOut()
    }
  },
  data () {
    return {
      isTriple: false,
      isShowModal: false,
      isConfirm: false,
      isSelect: false,
      isHideCancel: true,
      title: '알림',
      isGray: true,
      message: ''
    }
  }
}
</script>

<style>
.cstm-alert {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  max-width: 100%;
  width: 100%;
  padding: 0 16px;
  height: 48px !important;
  border-radius: 4px;
  border: 0 none;
  font-size: 14px !important;
  line-height: 18px;
  font-weight: 800;
  color: #333 !important;
}
.confirm-button {
  background: #a0f0e0 !important;
}

.confirm-button:active,
.confirm-button:hover {
  background: #53d9c1;
}

.confirm-button:disabled {
  background: #e6e6e6;
  color: #8b8b8b;
  cursor: default;
}

.cancel-button {
  background: #f0f0f0 !important;
}

.cancel-button:active,
.cancel-button:hover {
  background: #e6e6e6 !important;
}

.cancel-button:disabled {
  background: #e6e6e6 !important;
  color: #8b8b8b !important;
  cursor: default !important;
}

.danger-button {
  background: #ffb0b0 !important;
}

.danger-button:active,
.danger-button:hover {
  background: #ff8c8c !important;
}

.danger-button:disabled {
  background: #e6e6e6 !important;
  color: #b8b8b8 !important;
  cursor: default !important;
}

.alert_btn.dual-alert {
  display: flex;
  justify-content: center;
  align-items: flex-start;
  gap: 2px;
}

</style>



// WEBPACK FOOTER //
// src/modules/template/AlertTemplate.vue